var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZipIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#008000",
    fillRule: "evenodd",
    d: "M2 1.5a.5.5 0 0 1 .5-.5H9a.5.5 0 0 1 .354.146l2.5 2.5A.5.5 0 0 1 12 4v2h-1V5H8.5a.5.5 0 0 1-.5-.5V2H3v12h8v-.5h1v1a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5zm7 .707V4h1.793zM6.35 8H4V7h3a.5.5 0 0 1 .5.5V8a.5.5 0 0 1-.116.32L5.151 11H7.5v1h-3a.5.5 0 0 1-.5-.5V11a.5.5 0 0 1 .116-.32zm2.15 4V7h1v5zm2-5v5h1v-1.5h2a.5.5 0 0 0 .5-.5V7.5a.5.5 0 0 0-.5-.5zm1 2.5H13V8h-1.5z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZipIcon);
export default __webpack_public_path__ + "static/media/ZipIcon.ee9158c78306943f5eae381b8685136e.svg";
export { ForwardRef as ReactComponent };